import { render, staticRenderFns } from "./ExtraFiltersPopup.vue?vue&type=template&id=3a060c9a"
import script from "./ExtraFiltersPopup.vue?vue&type=script&lang=js"
export * from "./ExtraFiltersPopup.vue?vue&type=script&lang=js"
import style0 from "./ExtraFiltersPopup.vue?vue&type=style&index=0&id=3a060c9a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports